import { useState } from "react";
import { useAuth } from "../lib/AuthContext";

/**
 * Pantalla de login. Se muestra cuando no hay sesión activa. No usa el
 * shell (sidebar + main), es una tarjeta centrada.
 */
export function Login(): JSX.Element {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      const msg = (err as Error).message || "Error al iniciar sesión";
      // Traducimos códigos comunes.
      if (msg === "invalid_credentials") {
        setError("Usuario o contraseña incorrectos.");
      } else if (msg === "missing_credentials") {
        setError("Introduce usuario y contraseña.");
      } else {
        setError(msg);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-brand">
          <div className="brand-mark">EC</div>
          <div>
            <div className="brand-name">ConciliaEcilimp</div>
            <div className="brand-tag">Tesorería · Conciliación</div>
          </div>
        </div>
        <h1 className="login-title">Iniciar sesión</h1>
        <label className="login-field">
          <span>Usuario</span>
          <input
            type="text"
            value={username}
            autoComplete="username"
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
            disabled={busy}
            required
          />
        </label>
        <label className="login-field">
          <span>Contraseña</span>
          <input
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
            required
          />
        </label>
        {error && <div className="login-error">{error}</div>}
        <button type="submit" disabled={busy || !username || !password}>
          {busy ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
